import React from 'react';
import classnames from 'classnames';
import styles from '../../../styles/widgets/adverts/slider-view.module.scss';
import { CardsSlider } from '../../../components/cards-slider';

export const SliderView = ({ configuration, children, advertName }) => (
  <CardsSlider
    className={classnames(styles.carousel, styles.dots, styles.button)}
    sliderConfiguration={configuration}
    name={advertName}
  >
    {children}
  </CardsSlider>
);
